
import {defineComponent, ref} from 'vue'
import {PropType} from "vue/dist/vue";
import {UIStateDto} from "@/dtos/UIStateDto";
import {
  CatalogProductWithImageOverviewRestDtoModel
} from "@/models/api/pharma-cpc-product-mgmt/CatalogProductWithImageOverviewRestDtoModel";

// Define constants for the component
export const PRODUCT_SOURCE = {
  NOT_IN_CATALOG: "NOT_IN_CATALOG"
};

export default defineComponent({
  name: "ProductListTile",
  components: {},
  emits: ["deleteProduct"],
  props: {
    product: {
      type: Object as PropType<CatalogProductWithImageOverviewRestDtoModel>,
      required: true
    },
    isDropTarget: {
      type: Boolean,
      default: false
    },
    isDraggableAndDeletable: {
      type: Boolean,
      default: false
    },
    useProductCode: {
      type: Boolean,
      required: false,
      default: false
    },
    pageUI: {
      type: Object as PropType<UIStateDto>,
      required: false
    }
  },
  setup() {
    const showDragIcon = ref(false);
    return {showDragIcon};
  },
  computed: {
    productName(): string {
      if (this.product.product.product_info?.name) {
        if (this.product.product.product_info.name.length > 40) {
          return this.product.product.product_info.name.substring(0, 40) + '...';
        }
        return this.product.product.product_info.name;
      }
      return '';
    },
    isInCatalog(): boolean {
      return (!!this.product && this.product.product.product_source_code !== PRODUCT_SOURCE.NOT_IN_CATALOG);
    },
    codeToShow(): string {
      if (this.useProductCode || !this.product.product.product_info.cnk_code) {
        if (this.product.product.product_code.length > 20) {
          return this.product.product.product_code.substring(0, 20) + '...';
        }
        return this.product.product.product_code;
      }

      return this.product.product.product_info.cnk_code;
    }
  },
  methods: {
    deleteProduct(): void {
      this.$emit('deleteProduct', this.product);
    },
  }
})
